import React, { useState, useEffect, useRef } from "react";
import config from "../config/config";

const ContactUsPage = () => {
  // Use refs for form data instead of state
  const nameRef = useRef();
  const emailRef = useRef();
  const phoneRef = useRef();
  const companyRef = useRef();
  const subjectRef = useRef();
  const messageRef = useRef();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState("");

  // Simple fix to ensure component works properly
  useEffect(() => {
    // This useEffect helps React component mount correctly
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage("");

    // Get form data from refs
    const formData = {
      name: nameRef.current.value,
      email: emailRef.current.value,
      phone: phoneRef.current.value,
      company: companyRef.current.value,
      subject: subjectRef.current.value,
      message: messageRef.current.value,
    };

    try {
      const baseApiUrl = config.getApiUrl("");

      const response = await fetch(`${baseApiUrl}submit_contact_form.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (data.success) {
        setSubmitMessage(data.message);
        // Reset form
        nameRef.current.value = "";
        emailRef.current.value = "";
        phoneRef.current.value = "";
        companyRef.current.value = "";
        subjectRef.current.value = "";
        messageRef.current.value = "";
      } else {
        setSubmitMessage(
          data.message || "Failed to submit form. Please try again."
        );
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setSubmitMessage(
        "Network error. Please check your connection and try again."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      {/* Contact Us Hero Section */}
      <section
        className="contact-hero-section"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/ncg_contact.png)`,
          backgroundSize: "cover",
          backgroundPosition: "center center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="hero-overlay"></div>
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <h1 className="contact-hero-title">Contact Us</h1>
              <p className="contact-hero-subtitle">
                Get in Touch with NCG Corporate
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form and Info Section */}
      <section className="contact-main-section">
        <div className="container">
          <div className="row">
            {/* Contact Form */}
            <div className="col-12 col-lg-8">
              <div className="contact-form-wrapper">
                <h2 className="contact-form-title">Send us a Message</h2>
                <p className="contact-form-subtitle">
                  Have a question or need a quote? Fill out the form below and
                  we'll get back to you within 24 hours.
                </p>

                <form onSubmit={handleSubmit} className="contact-form" style={{position: "relative", zIndex: "10000"}}>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="name">Full Name *</label>
                        <input
                          type="text"
                          id="name"
                          name="name"
                          className="form-control"
                          ref={nameRef}
                          style={{pointerEvents: "auto", position: "relative", zIndex: "10001"}}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="email">Email Address *</label>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          className="form-control"
                          ref={emailRef}
                          style={{pointerEvents: "auto", position: "relative", zIndex: "10001"}}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="phone">Phone Number</label>
                        <input
                          type="tel"
                          id="phone"
                          name="phone"
                          className="form-control"
                          ref={phoneRef}
                          style={{pointerEvents: "auto", position: "relative", zIndex: "10001"}}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="company">Company Name</label>
                        <input
                          type="text"
                          id="company"
                          name="company"
                          className="form-control"
                          ref={companyRef}
                          style={{pointerEvents: "auto", position: "relative", zIndex: "10001"}}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="subject">Subject *</label>
                    <select
                      id="subject"
                      name="subject"
                      className="form-control"
                      ref={subjectRef}
                      style={{pointerEvents: "auto", position: "relative", zIndex: "10001"}}
                      required
                    >
                      <option value="">Select a subject</option>
                      <option value="general-inquiry">General Inquiry</option>
                      <option value="quote-request">Quote Request</option>
                      <option value="product-information">
                        Product Information
                      </option>
                      <option value="manufacturing-services">
                        Manufacturing Services
                      </option>
                      <option value="sourcing-services">
                        Sourcing Services
                      </option>
                      <option value="engineering-services">
                        Engineering Services
                      </option>
                      <option value="partnership">
                        Partnership Opportunity
                      </option>
                      <option value="support">Technical Support</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label htmlFor="message">Message *</label>
                    <textarea
                      id="message"
                      name="message"
                      className="form-control"
                      rows="6"
                      ref={messageRef}
                      style={{pointerEvents: "auto", position: "relative", zIndex: "10001"}}
                      placeholder="Please provide details about your inquiry..."
                      required
                    ></textarea>
                  </div>

                  {submitMessage && (
                    <div
                      className={`alert ${
                        submitMessage.includes("Thank you")
                          ? "alert-success"
                          : "alert-danger"
                      } mt-3`}
                    >
                      {submitMessage}
                    </div>
                  )}

                  <button
                    type="submit"
                    className="contact-submit-btn"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <i className="fas fa-spinner fa-spin me-2"></i>
                        Sending...
                      </>
                    ) : (
                      <>
                        Send Message <i className="fas fa-paper-plane ms-2"></i>
                      </>
                    )}
                  </button>
                </form>
              </div>
            </div>

            {/* Contact Information Sidebar */}
            <div className="col-12 col-lg-4">
              <div className="contact-info-sidebar">
                <h3 className="contact-info-title">Contact Information</h3>

                {/* Registered Office */}
                <div className="contact-info-block">
                  <div className="contact-info-icon">
                    <i className="fas fa-building"></i>
                  </div>
                  <div className="contact-info-content">
                    <h4>Registered Office</h4>
                    <p>
                      SCO: 117/118(2nd Floor), Sector -17/B,
                      <br />
                      Chandigarh, India, Pin- 160017
                    </p>
                    <p>
                      <strong>Phone:</strong>{" "}
                      <a href="tel:01724014825">0172-4014825</a>
                      <br />
                      <strong>Cell:</strong>{" "}
                      <a href="tel:+919779044006">+91-9779044006</a>
                    </p>
                  </div>
                </div>

                {/* Factory/Corporate Office */}
                <div className="contact-info-block">
                  <div className="contact-info-icon">
                    <i className="fas fa-industry"></i>
                  </div>
                  <div className="contact-info-content">
                    <h4>Factory/Corporate Office</h4>
                    <p>
                      Plot No. C-134, Industrial Area Phase VIII,
                      <br />
                      Sector 72, SAS Nagar Mohali, Punjab,
                      <br />
                      India, Pin- 160071
                    </p>
                    <p>
                      <strong>Cell:</strong>{" "}
                      <a href="tel:+919877078268">+91-9877078268</a> /{" "}
                      <a href="tel:+919779044006">+91-9779044006</a>
                    </p>
                  </div>
                </div>

                {/* Email */}
                <div className="contact-info-block">
                  <div className="contact-info-icon">
                    <i className="fas fa-envelope"></i>
                  </div>
                  <div className="contact-info-content">
                    <h4>Email</h4>
                    <p>
                      <a href="mailto:info@ncgcorporate.com">
                        info@ncgcorporate.com
                      </a>
                    </p>
                  </div>
                </div>

                {/* Business Hours */}
                <div className="contact-info-block">
                  <div className="contact-info-icon">
                    <i className="fas fa-clock"></i>
                  </div>
                  <div className="contact-info-content">
                    <h4>Business Hours</h4>
                    <p>
                      <strong>Monday - Friday:</strong> 9:00 AM - 6:00 PM
                      <br />
                      <strong>Saturday:</strong> 9:00 AM - 1:00 PM
                      <br />
                      <strong>Sunday:</strong> Closed
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="contact-map-section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h3 className="map-section-title">Find Us</h3>
              <div className="map-wrapper">
                <div className="map-placeholder">
                  <i className="fas fa-map-marker-alt"></i>
                  <p>Interactive Map Coming Soon</p>
                  <p className="map-address">
                    Plot No. C-134, Industrial Area Phase VIII,
                    <br />
                    Sector 72, SAS Nagar Mohali, Punjab, India
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Quick Contact CTA */}
      <section className="quick-contact-cta">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12 col-lg-8">
              <h3 className="cta-title">Need Immediate Assistance?</h3>
              <p className="cta-subtitle">
                Our team is ready to help you with your manufacturing and
                sourcing needs.
              </p>
            </div>
            <div className="col-12 col-lg-4 text-lg-end">
              <a href="tel:+919877078268" className="quick-call-btn">
                <i className="fas fa-phone me-2"></i>
                Call Now: +91-9877078268
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactUsPage;
